<template>
  <div class="wait-list">
    <button
      :class="[classes, linkStyle ? 'link link--pseudo' : 'btn wait-list__btn', {'is-product-page': productPage, 'is-small-card': smallCard}]"
      type="button"
      :disabled="btnDisable"
      :aria-label="title"
      @click.stop="changeWaitListFlag"
    >
      <svg v-if="!linkStyle && !isInWaitList"
           class="wait-list__btn-img"
           width="22"
           height="16"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M18.458 0H2.57A2.573 2.573 0 000 2.571v10.858A2.573 2.573 0 002.571 16h15.882a2.573 2.573 0 002.572-2.571V2.575A2.57 2.57 0 0018.457 0zm1.396 13.429c0 .77-.626 1.396-1.396 1.396H2.57c-.77 0-1.396-.626-1.396-1.396V2.575c0-.77.626-1.396 1.396-1.396h15.882c.77 0 1.397.626 1.397 1.396V13.43h.004z" fill="#3E3E3E"/>
        <path d="M13.26 7.865l5.142-4.611a.59.59 0 00.043-.831.59.59 0 00-.83-.043l-7.091 6.364L9.14 7.508c-.004-.004-.008-.008-.008-.013a.87.87 0 00-.096-.082l-5.63-5.038a.587.587 0 00-.83.048.587.587 0 00.048.83l5.202 4.651-5.18 4.85a.59.59 0 00.804.862l5.26-4.92 1.426 1.275a.587.587 0 00.783-.005l1.466-1.313 5.23 4.967a.587.587 0 10.81-.853l-5.165-4.902z" fill="#3E3E3E"/>
      </svg>
      {{ title }}
    </button>
    <span v-if="isInWaitList && !isSmallCard && !linkStyle"
          class="wait-list__response">{{ $t('added_to_wait_list') }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'WaitListBtn',
  props: {
    productId: {
      type: Number,
      default: null
    },
    inWaitListStatus: {
      type: Boolean,
      default: false
    },
    classes: String,
    isSmallCard: Boolean,
    isMapModal: Boolean,
    linkStyle: Boolean,
    productPage: {
      type: Boolean,
      default: false
    },
    smallCard: {
      type: Boolean,
      default: false
    },
    storeId: {
      type: Number
    }
  },
  data: function () {
    return {
      token: '',
      btnDisable: false
    }
  },
  methods: {
    ...mapActions('waitlist', ['CHANGE_WAIT_LIST_STATUS']),
    changeWaitListFlag () {
      if (this.user && this.user.auth) {
        const infoModalWaitListBtn = document.getElementById(`wait-list-btn-${this.storeId}`)
        let postData

        if (this.storeId) {
          postData = {
            product_id: this.productId,
            remove: +this.isInWaitList,
            store_id: this.storeId
          }
        } else {
          postData = {
            product_id: this.productId,
            remove: +this.isInWaitList
          }
        }

        this.btnDisable = true

        this.CHANGE_WAIT_LIST_STATUS({ postData: postData })
          .then(response => {
            if (infoModalWaitListBtn) {
              infoModalWaitListBtn.innerText = this.isInWaitList ? this.$t('already_in_wait_list') : this.$t('add_to_wait_list')
            }

            this.btnDisable = false
            if (!this.isMapModal) this.notifySuccess(response.message)
          })
          .catch(error => {
            if (!this.isMapModal) this.notifyError(error)
          })
      } else {
        window.addEventListener('waitListTrigger', () => {
          if (!this.isInWaitList) this.changeWaitListFlag()
        })

        this.$modal.show('auth-modal', {
          title: this.$t('wait_list_auth_message'),
          isAjaxAuth: true,
          referrer: 'wait-list'
        })
      }
    },
    notifySuccess (message) {
      this.$notify({
        group: 'success',
        title: '',
        text: message,
        type: 'success'
      })
    },
    notifyError (message) {
      this.$notify({
        group: 'error',
        title: this.$t('error'),
        text: message,
        type: 'error'
      })
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapGetters('waitlist', ['productsIdsInWaitlist']),
    ...mapState('waitlist', ['waitListStatusInShops']),
    user () {
      return this.$store.state.user
    },
    title () {
      if (this.isMapModal) return this.isInWaitList ? this.$t('already_in_wait_list_store') : this.$t('add_to_wait_list_store')

      return this.isInWaitList ? this.$t('already_in_wait_list') : this.$t('add_to_wait_list')
    },
    isInWaitList () {
      if (this.storeId) return this.waitListStatusInShops[this.storeId]

      return this.productsIdsInWaitlist.includes(this.productId)
    }
  }
}
</script>

<style lang="sass" scoped>

/*.wait-list*/

.link
  background-color: transparent
  font-size: 14px
  font-weight: 400 //Rubik 300

.wait-list__btn
  display: flex
  font-size: 14px
  min-width: 200px
  justify-content: center
  align-items: center
  padding: 0 15px
  background-color: #f0f0f0
  color: $text-color
  border-color: transparent
  height: 46px

  &:hover,
  &:focus
    background-color: transparent
    border-color: #e1e1e1

.wait-list__btn--small
  height: auto
  padding: 6px 22px 7px
  font-size: 12px
  min-width: auto

  .wait-list__btn-img
    display: none

.wait-list--map-modal
  width: 48%

.wait-list--map-modal .wait-list__btn
  width: 100%
  display: block
  padding: 10px 0
  height: auto
  line-height: 18px

.wait-list--card .wait-list__btn
  height: 33px
  min-width: 170px
  padding: 0 8px

  +mmax(550)
    height: 45px

  +mmax(359)
    height: 37px

.wait-list__btn-img
  line-height: 0
  margin-right: 10px
  flex-shrink: 0

.wait-list--map-modal .wait-list__btn-img,
.wait-list--card .wait-list__btn-img
  display: none

.wait-list__response
  display: flex
  align-items: center
  margin-top: 20px
  font-size: 14px
  font-weight: 400 //Rubik 300

  &:before
    content: ''
    display: block
    width: 20px
    height: 20px
    margin-right: 15px
    background-image: url(/img/svgo/product-page/wait-list.svg)
    background-repeat: no-repeat

.is-product-page
  width: 100%
  height: 50px
  padding: 0 31px

  +mmin($tablet)
    height: 40px

  +mmin(1360)
    width: auto

.is-product-page.is-small-card
  width: 100%
</style>
